<template>
  <bg-style class="store-v3-item" :class="{ 'is-mobile': $store.getters.isMobile }"
    :bg="active ? model.activeCardBackground : model.cardBackground">
    <im-image v-if="isHasCorner" :src="good.corner" class="corner-logo" />
    <img v-if="good.icon" class="absolute icon w-[70%] left-1/2 -translate-x-1/2" :src="good.icon" alt="">
    <div class="flex justify-center gifts shadow-stroke-num font-SairaBlack leading-none">
      <span v-if="good.item_contents?.[0]">{{ good.item_contents?.[0]?.num }}</span>
    </div>
    <div class="flex flex-col items-center extra justify-center shadow-stroke-num font-GemunuLibreExtraBold leading-none">
      <div v-if="good.gift_list?.[0]" class="flex items-center justify-center">
        <span class="">{{ $t('siteBuild.extraGift') }}</span>
        <i class="el-icon-close" />
        <span>{{ good.gift_list?.[0]?.num }}</span>
      </div>
    </div>
    <div class="price">
      <div v-if="isShowCountdown" class="flex items-center justify-center">
        <i class="el-icon-time mr-1" />
        <template v-if="countdownDays === '00' && countdownHours !== '00'">
          <span>{{ countdownHours }}h:{{ countdownMinutes }}m</span>
        </template>
        <template v-if="countdownDays !== '00'">
          <span>{{ countdownDays }}d:{{ countdownHours }}h</span>
        </template>
        <template v-if="countdownDays === '00' && countdownHours === '00'">
          <span>{{ countdownMinutes }}m:{{ countdownSeconds }}s</span>
        </template>
      </div>
      <template v-else>
        <span>{{ priceInfo.priceTxt }}</span>
        <span v-if="hasOriginalPrice" class="line-through original">{{ originalPriceInfo.priceTxt }}</span>
      </template>
    </div>
    <!-- <div class="flex items-center justify-center relative content">
      <template v-if="good.item_contents?.[0]">
        <img :src="good.item_contents?.[0]?.icon" alt="">
        <i class="el-icon-close" />
        <span>{{ good.item_contents?.[0]?.num }}</span>
      </template>
</div>

<div class="flex items-center gifts relative justify-center">
  <template v-if="good.gift_list?.[0]">
        <span>{{ $t('siteBuild.extraGift') }}</span>
        <img class="ml-1" :src="good.gift_list?.[0]?.gift_goods_logo" alt="">
        <i class="el-icon-close" />
        <span class="number">{{ good.gift_list?.[0]?.num }}</span>
      </template>
</div>
<div class="price relative text-center">
  <div v-if="isShowCountdown" class="flex items-center justify-center">
    <i class="el-icon-time mr-1" />
    <template v-if="countdownDays === '00' && countdownHours !== '00'">
          <span>{{ countdownHours }}h:{{ countdownMinutes }}m</span>
        </template>
    <template v-if="countdownDays !== '00'">
          <span>{{ countdownDays }}d:{{ countdownHours }}h</span>
        </template>
    <template v-if="countdownDays === '00' && countdownHours === '00'">
          <span>{{ countdownMinutes }}m:{{ countdownSeconds }}s</span>
        </template>
  </div>
  <template v-else>
        <span>{{ labelPriceText }}</span>
        <span v-if="isShowOriginalPrice" class="line-through original">{{ originalLabelPriceText }}</span>
      </template>
</div> -->
  </bg-style>
</template>

<script>
import GoodsMixin from '../storeWidget/oneGood/goodMixins'
export default {
  mixins: [GoodsMixin],
  props: {
    model: Object,
    active: Boolean
  }
}
</script>

<style lang="less">
.store-v3-item {
  width: 100%;
  height: 240px;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;

  .corner-logo {
    position: absolute;
    width: 35%;
    height: 35%;
    top: -20px;
    left: -8px;
  }

  .icon {
    top: 64px;
  }


  .gifts {
    font-weight: bold;
    color: var(--text-color);
    position: absolute;
    width: 100%;
    bottom: 100px;
    font-size: 24px;
    width: 100%;
    text-align: center;
  }

  .extra {
    font-weight: bold;
    color: var(--text-color);
    position: absolute;
    width: 100%;
    bottom: 80px;
    font-size: 16px;
  }
  .shadow-stroke-num {
    text-shadow: -1px -1px 1px #6F241A, 1px -1px 1px #6F241A, -1px 1px 1px #6F241A, 1px 1px 1px #6F241A, 0px -2px 0px #6F241A, 0px 2px 1px #6F241A, -2px 0px 0px #6F241A, 2px 0px 0px #6F241A;
  }
  .price {
    font-weight: bold;
    font-size: 27px;
    color: var(--price-color);
    bottom: 16px;
    position: absolute;
    width: 100%;
    ;
    text-align: center;

    .original {
      font-size: 12px;
      margin-left: 5px;
    }
  }

  &.is-mobile {
    width: 100%;
    height: 125px;
    padding-top: 16px;
    padding-bottom: 2px;
    .shadow-stroke-num {
      text-shadow: -1px -1px 1px #6F241A, 1px -1px 1px #6F241A, -1px 1px 1px #6F241A, 1px 1px 1px #6F241A, 0px -2px 0px #6F241A, 0px 2px 1px #6F241A, -2px 0px 0px #6F241A, 2px 0px 0px #6F241A;;
    }
    .corner-logo {
      width: 30%;
      height: 30%;
      top: -10px;
      left: -5px;
    }

    .icon {
      top: 28px;
    }

    .gifts {
      font-size: 14px;
      bottom: 54px;
    }

    .extra {
      font-size: 7px;
      bottom: 42px;
    }

    .price {
      font-size: 15px;
      bottom: 8px;
    }
  }
}
</style>
